import React, { useState } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import { apiService } from '../services/api';
import { format } from 'date-fns';

const LateSubmissionsList = ({ lateSubmissions }) => {
  const [loading, setLoading] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleSendReminder = async (submission) => {
    setLoading(prev => ({ ...prev, [submission.user_id]: true }));
  
    try {
      await apiService.sendReminderEmail(submission.user_id);
      setSnackbar({
        open: true,
        message: `Reminder sent successfully to ${submission.driver_name}`,
        severity: 'success'
      });
    } catch (error) {
      console.error('Error sending reminder:', error);
      setSnackbar({
        open: true,
        message: `Failed to send reminder: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setLoading(prev => ({ ...prev, [submission.user_id]: false }));
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  if (!lateSubmissions || lateSubmissions.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No late submissions found
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="late submissions table" size="medium">
          <TableHead>
            <TableRow>
              <TableCell>Driver</TableCell>
              <TableCell>Vehicle</TableCell>
              <TableCell>Last Submission</TableCell>
              <TableCell>Days Late</TableCell>
              <TableCell>Branch</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lateSubmissions.map((submission) => (
              <TableRow key={submission.user_id || `temp-${submission.driver_name}`}>
                <TableCell>{submission.driver_name}</TableCell>
                <TableCell>{submission.vehicle_number || 'N/A'}</TableCell>
                <TableCell>
                  {submission.date ? format(new Date(submission.date), 'MM/dd/yyyy') : 'N/A'}
                </TableCell>
                <TableCell>{submission.days_late}</TableCell>
                <TableCell>{submission.branch}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleSendReminder(submission)}
                    disabled={loading[submission.user_id]}
                    sx={{ minWidth: '140px' }}
                  >
                    {loading[submission.user_id] ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      'Send Reminder'
                    )}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LateSubmissionsList;